import { graphql } from 'react-relay';

import { queryAgg } from '@confluence/query-preloader-tools/entry-points/graphql';

import type {
	preloadMentionsUsersUsersQuery$data,
	preloadMentionsUsersUsersQuery$variables,
} from './__generated__/preloadMentionsUsersUsersQuery.graphql';

type UserIdAri = `ari:cloud:identity::user/${string}`;
const ARI_PREFIX = 'ari:cloud:identity::user/';

export const MENTIONS_LOOKUP_LIMIT = 50;

export type MentionUserEntry = {
	id?: string | null;
	name?: string | null;
};

const PreloadMentionsUsersUsersQuery = graphql`
	query preloadMentionsUsersUsersQuery($ids: [ID!]!) {
		users(accountIds: $ids) {
			id
			name
		}
	}
`;

type GetUserDataReturn = preloadMentionsUsersUsersQuery$data['users'] | null | undefined;

const getUserData = async (ids: UserIdAri[]): Promise<GetUserDataReturn> => {
	const { data } = await queryAgg<
		preloadMentionsUsersUsersQuery$data,
		preloadMentionsUsersUsersQuery$variables
	>({
		query: PreloadMentionsUsersUsersQuery,
		variables: {
			ids,
		},
	});

	return data?.users;
};

export const preloadMentionsUsers = async (userIds: string[]): Promise<MentionUserEntry[]> => {
	const ids = userIds.map((id: string) => `${ARI_PREFIX}${id}`) as UserIdAri[];
	const users = await getUserData(ids);

	return (users || []).map((user) => ({
		id: user?.id?.replace(ARI_PREFIX, ''),
		name: user?.name,
	}));
};
